import React, { useContext } from 'react';
import { bool, shape, string } from 'prop-types';
import classNames from 'classnames/bind';
import {
  Button, Card, CardTitle, CardContent, Col, Row
} from '@thd-olt-component-react/core-ui';
import {
  StorePod,
  StorePodPhoneNumber,
  StorePodHours,
  StorePodAddress,
  StorePodMap,
  StorePodLink
} from '@thd-olt-component-react/store-pod';
import { StoreHeroContext } from '../../StoreHero.context';
import styles from './store-hero-details.module.scss';

const cx = classNames.bind(styles);

const StoreHeroDetails = ({
  className,
  phoneNumbers,
  showStoreDetailsButton,
  title
}) => {
  const mapOptions = {
    height: '60',
    width: '60'
  };

  const { loading, store } = useContext(StoreHeroContext);
  const { storeDetailsPageLink } = store || {};

  const handleViewStoreDetailsClick = () => {
    window.location.href = storeDetailsPageLink;
  };

  const phoneNumbersMerged = { ...StoreHeroDetails.defaultProps.phoneNumbers, ...phoneNumbers };

  return (
    <Card className={cx(className, 'store-hero-details')} sharp>
      <CardTitle title={title} />
      <CardContent>
        <StorePod loading={loading} store={store}>
          <div className={cx('store-hero-details__wrapper')}>
            <Row>
              <Col nopadding fallback={6} xs={6}>
                <span className={cx('store-hero-details__header')}>Contact Us</span>
                {Object.keys(phoneNumbersMerged).map((key) => {
                  if (phoneNumbersMerged[key]) {
                    return (
                      <StorePodPhoneNumber
                        boldLabel
                        className={cx('store-hero-details__pod')}
                        displayMultiline
                        type={key}
                      />
                    );
                  }
                  return null;
                })}
              </Col>
              <Col nopadding fallback={6} xs={6}>
                <span className={cx('store-hero-details__header')}>Store Hours</span>
                <StorePodHours
                  className={cx('store-hero-details__pod')}
                  displayMultiline
                />
                <StorePodHours
                  className={cx('store-hero-details__pod')}
                  displayMultiline
                  curbside
                />
              </Col>
            </Row>
            <Row>
              <Col nopadding className={cx('store-hero-details__pod--space-between')}>
                <div>
                  <span className={cx('store-hero-details__header')}>Location</span>
                  <StorePodAddress className={cx('store-hero-details__pod')} placeholderWidth={95} />
                </div>
                <StorePodMap
                  mapOptions={mapOptions}
                  className={cx('store-hero-details__map-preview', 'details__pod')}
                />
              </Col>
            </Row>
            <Row>
              <Col nopadding fallback={12} className={cx('store-hero-details__pod--space-between')}>
                <StorePodLink
                  className={cx('store-hero-details__link')}
                  placeholderWidth={95}
                  type="localAd"
                />
                <StorePodLink
                  className={cx('store-hero-details__link')}
                  placeholderWidth={90}
                  type="directions"
                />
              </Col>
            </Row>
            {showStoreDetailsButton && (
              <Row>
                <Col nopadding>
                  <Button outline onClick={handleViewStoreDetailsClick}>View Store Details</Button>
                </Col>
              </Row>
            )}
          </div>
        </StorePod>
      </CardContent>
    </Card>
  );
};

StoreHeroDetails.propTypes = {
  className: string,
  phoneNumbers: shape({
    services: bool,
    store: bool,
    pro: bool,
    tool: bool
  }),
  showStoreDetailsButton: bool,
  title: string
};

StoreHeroDetails.defaultProps = {
  className: null,
  phoneNumbers: {
    services: false,
    store: true,
    pro: true,
    tool: true
  },
  showStoreDetailsButton: false,
  title: 'Store Details'
};

StoreHeroDetails.displayName = 'StoreHeroDetails';

export { StoreHeroDetails };
